import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=17a9aa77&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=17a9aa77&prod&lang=scss&scoped=true&"
import style1 from "./Projects.vue?vue&type=style&index=1&id=17a9aa77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a9aa77",
  null
  
)

export default component.exports